import {
  createIndex as publicCreateIndex,
  dropIndex as publicDropIndex,
  listIndexes as publicListIndexes,
  listAvailableIndexes as publicListAvailableIndexes,
} from './data-v2-index-indexes.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onIndexCreated as publicOnIndexCreated } from './data-v2-index-indexes.public.js';
import { onIndexDeleted as publicOnIndexDeleted } from './data-v2-index-indexes.public.js';
import { onIndexUpdated as publicOnIndexUpdated } from './data-v2-index-indexes.public.js';

export const createIndex: MaybeContext<
  BuildRESTFunction<typeof publicCreateIndex> & typeof publicCreateIndex
> = /*#__PURE__*/ createRESTModule(publicCreateIndex);
export const dropIndex: MaybeContext<
  BuildRESTFunction<typeof publicDropIndex> & typeof publicDropIndex
> = /*#__PURE__*/ createRESTModule(publicDropIndex);
export const listIndexes: MaybeContext<
  BuildRESTFunction<typeof publicListIndexes> & typeof publicListIndexes
> = /*#__PURE__*/ createRESTModule(publicListIndexes);
/** @internal */
export const listAvailableIndexes: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableIndexes> &
    typeof publicListAvailableIndexes
> = /*#__PURE__*/ createRESTModule(publicListAvailableIndexes);
/**
 * Triggered when an index is created.
 */
export const onIndexCreated: BuildEventDefinition<typeof publicOnIndexCreated> &
  typeof publicOnIndexCreated = createEventModule(publicOnIndexCreated);
/**
 * Triggered when an index is dropped.
 */
export const onIndexDeleted: BuildEventDefinition<typeof publicOnIndexDeleted> &
  typeof publicOnIndexDeleted = createEventModule(publicOnIndexDeleted);
/**
 * Triggered when an index's status field is updated.
 *
 * For example, during index creation, the index's status transitions from `BUILDING` to `ACTIVE` or `FAILED`. Either transition triggers this event.
 */
export const onIndexUpdated: BuildEventDefinition<typeof publicOnIndexUpdated> &
  typeof publicOnIndexUpdated = createEventModule(publicOnIndexUpdated);

export {
  Order,
  Status,
  IndexSource,
  Environment,
  WebhookIdentityType,
} from './data-v2-index-indexes.universal.js';
export {
  Index,
  Field,
  Failure,
  CreateIndexRequest,
  CreateIndexResponse,
  DropIndexRequest,
  DropIndexResponse,
  ListIndexesRequest,
  Paging,
  ListIndexesResponse,
  PagingMetadata,
  ListAvailableIndexesRequest,
  ListAvailableIndexesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  IndexCreatedEnvelope,
  IndexDeletedEnvelope,
  IndexUpdatedEnvelope,
  ListIndexesOptions,
} from './data-v2-index-indexes.universal.js';
export {
  OrderWithLiterals,
  StatusWithLiterals,
  IndexSourceWithLiterals,
  EnvironmentWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-v2-index-indexes.universal.js';
